import asyncComponent from './AsyncComponent';

export default asyncComponent;
